import { render } from "./Alert1.vue?vue&type=template&id=0ec8436b"
import script from "./Alert1.vue?vue&type=script&lang=js"
export * from "./Alert1.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__